<template>
  <Container :list="this.$nav20" title="多彩校园" v-if="isMaxScreen">
    <div class="box">
         <div class="breadcrumb" v-if="isMaxScreen">
        <router-link to="/" class="breadcrumb-item">
          首页
        </router-link>
         -
        <span
          @click="revert"
          class="breadcrumb-item">多彩校园</span>
        -
        <span class="breadcrumb-item">视频详情</span>
      </div>
      <div class="video-box">
          <video class="myVideo"
                autoplay="autoplay"
                muted
                controls
                :src="$route.query.url" type="video/mp4"
                >
          </video>
      </div>
    </div>
  </Container>

  <DetailsH5 v-else />
</template>

<script>
import Container from '@/components/Container/index'
import { mapState } from 'vuex'
import DetailsH5 from '@/views/app/video/videoDetails/index'

export default {
  name: 'vDetails',
  components: { Container, DetailsH5 },
  props: {},
  data () {
    return {
      isMaxScreen: true
    }
  },
  computed: {
    ...mapState({
      sidebar: state => state.sidebar
    })
  },
  watch: {
    screenWidth: function (val) {
      // 监听屏幕宽度变化
      // console.log("val",val)
      this.isMaxScreen = val > 850
      // alert('ppp')
    }
  },
  created () {
  },
  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      console.log('外部', document.body.clientWidth)
      this.isMaxScreen = document.body.clientWidth > 850
      // console.log("this.isMaxScreen",this.isMaxScreen)
      // console.log(99999999999999999999999999999)
    })
  },
  methods: {
    revert () {
      this.$router.push('/campus?ids=0')
    }
  }
}
</script>

<style lang="scss" scoped>
 $wh: 88px;
 $vwh: 100%;
 $tf: 50%;
.box{
  .videoTitle {
      font-size: 16px;
      text-align: center;
    }
  .video-box{
      width: 800px;
      height:480px;
      margin: 0;
      position: relative;
      cursor: pointer;
      margin-bottom: 14px;
       .myVideo{
          width: $vwh;
          height: $vwh;
          object-fit: cover;
        }
        .video_play {
          position: absolute;
          top: $tf;
          left: $tf;
          transform: translate(-$tf, -$tf);
          width: $wh;
          height: $wh;
          border-radius: $tf;
          // background: url('~@/assets/play2x.png') center no-repeat;
          background-size: $vwh;
          z-index: 99;

        }

  }
  .title{
    margin-bottom: 20px;
    height: 32px;
    border-bottom: 1px solid #efefef;
    .title-left{
      display: flex;
      align-items: center;
      font-size: 20px;
      color: #0d5097;
      span{
        font-size: 16px;
        color:#0F4179;
        margin-left: 5px;
      }
    }
  }
}

</style>
